const TabsContext = React.createContext ();

function Tabs( { defaultValue = undefined, value = undefined, onOpenChange, className, style, children } )
{
    const [state, setState] = React.useState({
        active: value || defaultValue,
    } );
    
    const onOpenClose = (value) => {
        if (value === state.active)
            return
        
        setState({
            active: value
        });
        onOpenChange && onOpenChange(value)
    }
    
    React.useEffect(() => {
        if (value !== undefined) {
            setState({
                active: value
            });
        }
    }, [ value ])
    
    const context = {
        ...state,
        _onOpenClose: onOpenClose,
    }
    
    return (
        <TabsContext.Provider value={ context }>
            <div className={className} style={style}>
                {children}
            </div>
        </TabsContext.Provider>
    );
}

const TabsList = ( { tag: Comp = 'div', className, style, children } ) =>
{
    return (
        <Comp className={className} style={style}>
            {children}
        </Comp>
    );
}

const TabsTrigger = ( { value, className, style, children } ) =>
{
    const { _onOpenClose, active } = React.useContext(TabsContext);
    
    const handleClick = () => {
        _onOpenClose(value)
    }
    
    return (
        <a role="button" className={cn("cursor-pointer", className, value === active && 'active')} style={style} onClick={handleClick}>
            {children}
        </a>
    );
}

const TabsContent = ({ value, className, style, children }) =>
{
    const ref = React.useRef(null);
    const { active } = React.useContext(TabsContext);
    
    React.useEffect(() => {
        if (ref.current === null) return
        
        if (active === value) {
            $(ref.current).fadeIn()
        } else {
            $(ref.current).hide()
        }
    }, [ active, value ])
    
    return (
        <div ref={ref} className={className} style={style}>
            {children}
        </div>
    );
}

export {
    Tabs,
    TabsList,
    TabsTrigger,
    TabsContent
}